import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { DocumentoElectronicoService } from 'src/app/services/documento-electronico.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { EmpresasRecibidosModalObservacionesComponent } from '../modal-observaciones/modal-observaciones.component';
import { EmpresasRecibidosModalRespComComponent } from '../modal-resp-com/modal-resp-com.component';

export interface IInputParams {
  desde: Date 
  hasta: Date
  tipo_dte_codigo: number
  statusDocumento: number
}
@Component({
  selector: 'app-empresas-recibidos-table-intercambio-empresas',
  templateUrl: './table-intercambio-empresas.component.html',
  styleUrls: ['../empresas-recibidos.component.scss'],
  providers: [SecurityService]
})
export class EmpresasRecibidosTableIntercambioEmpresasComponent implements OnInit {

  @Input() visible: boolean = false
  @ViewChild(EmpresasRecibidosModalObservacionesComponent, { static: true }) observacionesModal: EmpresasRecibidosModalObservacionesComponent
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent
  @ViewChild(EmpresasRecibidosModalRespComComponent, { static: true }) respComModal: EmpresasRecibidosModalRespComComponent

  // Data & Tmp
  rutEmpresa: number
  sucursalCodigo: number
  loading: boolean = false
  listaDocumentos: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()

  params: IInputParams = null

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private documentoElectronicoService: DocumentoElectronicoService,
    public rutService: RutService
  ) {
    this.log = this.clog.log('EMPRESAS-RECIBIDOS / INTERCAMBIO-EMPRESAS')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo())

    this.paginationContext.RecordsByPage = 10
  }

  loadAndShow(params: IInputParams): boolean {
    try {
      this.params = params
      this.buscar(1)
      return true
    } catch { return false }
  }

  buscar(pageNumber: number = 1) {
    this.listaDocumentos = []
    this.loading = true

    this.paginationContext.CurrentPage = pageNumber

    const { desde, hasta, tipo_dte_codigo, statusDocumento } = this.params
    const inputParams = {
      empresa_rut: this.rutEmpresa,
      desde,
      hasta,
      tipo_dte_codigo,
      statusDocumento : statusDocumento ? statusDocumento : 0,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.log('inputParams', JSON.stringify(inputParams))
    this.documentoElectronicoService.obtenerRecibidosIntercambioEmpresas(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaDocumentos = registros

      // // FIXME: This is a modification to data in order to test show/hide budges/buttons
      // this.listaDocumentos[0].intento_envio_al_sii = true
      // this.listaDocumentos[0].acuse_recibo = null
      // this.listaDocumentos[0].recepcion_mercaderia = true
      // this.listaDocumentos[0].respuesta_comercial = true
      // this.listaDocumentos[0].total_bruto = 0

      // this.listaDocumentos[1].intento_envio_al_sii = true
      // this.listaDocumentos[1].acuse_recibo = true
      // this.listaDocumentos[1].recepcion_mercaderia = null
      // this.listaDocumentos[1].respuesta_comercial = null
      // this.listaDocumentos[1].total_bruto = 100

      // this.listaDocumentos[2].intento_envio_al_sii = true
      // this.listaDocumentos[2].acuse_recibo = true
      // this.listaDocumentos[2].recepcion_mercaderia = null
      // this.listaDocumentos[2].respuesta_comercial = false
      // this.listaDocumentos[2].total_bruto = 200

      // this.listaDocumentos[3].intento_envio_al_sii = true
      // this.listaDocumentos[3].acuse_recibo = true
      // this.listaDocumentos[3].recepcion_mercaderia = true
      // this.listaDocumentos[3].respuesta_comercial = false
      // this.listaDocumentos[3].total_bruto = 300

      // this.listaDocumentos[4].intento_envio_al_sii = true
      // this.listaDocumentos[4].acuse_recibo = true
      // this.listaDocumentos[4].recepcion_mercaderia = null
      // this.listaDocumentos[4].respuesta_comercial = true
      // this.listaDocumentos[4].total_bruto = 400

      // this.listaDocumentos[5].intento_envio_al_sii = true
      // this.listaDocumentos[5].acuse_recibo = true
      // this.listaDocumentos[5].recepcion_mercaderia = true
      // this.listaDocumentos[5].respuesta_comercial = null
      // this.listaDocumentos[5].total_bruto = 500

      // this.listaDocumentos[6].intento_envio_al_sii = true
      // this.listaDocumentos[6].acuse_recibo = true
      // this.listaDocumentos[6].recepcion_mercaderia = false
      // this.listaDocumentos[6].respuesta_comercial = null
      // this.listaDocumentos[6].total_bruto = 600

      // this.listaDocumentos[7].intento_envio_al_sii = true
      // this.listaDocumentos[7].acuse_recibo = true
      // this.listaDocumentos[7].recepcion_mercaderia = true
      // this.listaDocumentos[7].respuesta_comercial = true
      // this.listaDocumentos[7].total_bruto = 700

      // this.listaDocumentos[8].intento_envio_al_sii = true
      // this.listaDocumentos[8].acuse_recibo = true
      // this.listaDocumentos[8].recepcion_mercaderia = null
      // this.listaDocumentos[8].respuesta_comercial = true
      // this.listaDocumentos[8].total_bruto = 800

      this.listaDocumentos.forEach((doc, index) => {
        // https://dcore.atlassian.net/browse/ISSTEC-36. Solicitado así
        // doc.acuse_recibo = true

        this.setDocAdditionalData(doc, index)
      })

      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  setDocAdditionalData(doc, index: number) {
    doc.rutFormato = this.rutService.AgregarDV(doc.rut)
    doc.index = index

    doc.showAROptions = false
    doc.showAcSendButton = false
    doc.ARLoading = false
    // Mostrar Recepcion de Mercaderias
    doc.showRecMercOptions = false
    doc.showRecMercSendButton = false
    doc.RecMercLoading = false

    doc.showRespComOptions = false
    doc.showRespComSendButton = false
    doc.RespComLoading = false

    /*if (doc.acuse_recibo === null) {
      doc.showAROptions = true
      doc.showAcSendButton = true
      doc.showRecMercOptions = true
      doc.showRespComOptions = true
    } else*/ 
    {
      doc.showAROptions = true
      doc.showAcSendButton = doc.acuse_recibo === null
      /*
      if (doc.acuse_recibo === true) {
        doc.showRecMercOptions = true
        doc.showRespComOptions = true 
      }*/
      //doc.showRecMercSendButton = doc.recepcion_mercaderia === null
      if (doc.recepcion_mercaderia === null) {
        doc.showRecMercSendButton = true
        doc.showRecMercOptions = true
      } else {
        doc.showRecMercSendButton = false
        doc.showRecMercOptions = true
      }
/*
      doc.showRespComSendButton = doc.respuesta_comercial === null

      if (doc.respuesta_comercial !== null) {
        doc.showRecMercSendButton = false
      }*/

      if (doc.respuesta_comercial === null) {
        doc.showRespComSendButton = true
        doc.showRespComOptions = true
      } else {
        doc.showRespComSendButton = false
        doc.showRespComOptions = doc.respuesta_comercial
      }
    }

    // // TODO: Remove me! I'm only exist for dev purposes
    // doc.showRecMercOptions = true
    // doc.showRecMercSendButton = true
    // doc.showRespComOptions = true
    // doc.showRespComSendButton = true
    // // Dev purposes end
  }

  reSend({ id_lsoft, index }) {
    this.modalConfirm.showWithInlineConfig("Confirmar solicitud", "¿Desea solicitar envío de acuse de recibo?", () => {

      const doc = this.listaDocumentos.filter(p => p.index === index)[0]
      doc.ARLoading = true

      this.documentoElectronicoService.enviarRecibidoAcuseRecibo({
        empresa_rut: this.rutEmpresa,
        id_lsoft,
        type: 1
      }, ({ mensajes, respuesta }) => {
        doc.ARLoading = false

        const ok = respuesta !== null && respuesta !== undefined
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        if (!respuesta) {
          this.toastService.error('No se pudo enviar el email')
          return
        }

        this.toastService.success('Email enviado')
        this.buscar(this.paginationContext.CurrentPage);
      })
    })
  }

  showModalObservaciones(type: 'RECEP_MERCADERIA' | 'RTA_COMERCIAL', { id_lsoft, index }) {
    switch (type) {
      // case 'RECEP_MERCADERIA':
      //   this.observacionesModal.show({ acceptCallback: this.EnvioAsignacionDocumentoRecepcionMercaderia, additionalData: { id_lsoft, index } })
      //   break
      case 'RTA_COMERCIAL':
        this.respComModal.show({ acceptCallback: this.EnvioAsignacionDocumentoRespuestaComercial, additionalData: { id_lsoft, index } })
        break
      default:
        return
    }
  }

  // EnvioAsignacionDocumentoRecepcionMercaderia = (aprobado: boolean, observacion: string, additionalData: any) => {
  //   const { id_lsoft, index } = additionalData

  //   const doc = this.listaDocumentos.filter(p => p.index === index)[0]
  //   doc.RecMercLoading = true

  //   this.documentoElectronicoService.enviarRecibidoRecepcionMercaderia({
  //     empresa_rut: this.rutEmpresa,
  //     sucursal_codigo: this.sucursalCodigo,
  //     id_lsoft,
  //   }, ({ mensajes, respuesta }) => {
  //     doc.RecMercLoading = false

  //     const ok = respuesta !== null && respuesta !== undefined
  //     if (!ok) {
  //       this.messageRendererService.showErrors(mensajes)
  //       return
  //     }

  //     if (!respuesta) {
  //       this.toastService.error('No se pudo enviar la solicitud')
  //       return
  //     }

  //     doc.recepcion_mercaderia = aprobado
  //     this.setDocAdditionalData(doc, index)
  //     this.toastService.success('Solicitud enviada')
  //     // this.buscar(this.paginationContext.CurrentPage);
  //   })
  // }

  showModalEnvioAsignacionDocumentoRecepcionMercaderia(additionalData) {
    const { id_lsoft, index } = additionalData

    this.modalConfirm.showWithInlineConfig("Confirmar operacion", "¿Desea enviar recepción de mercadería?", () => {
      const doc = this.listaDocumentos.filter(p => p.index === index)[0]
      doc.RecMercLoading = true

      this.documentoElectronicoService.enviarRecibidoRecepcionMercaderia({
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        id_lsoft,
      }, ({ mensajes, respuesta }) => {
        doc.RecMercLoading = false

        const ok = respuesta !== null && respuesta !== undefined
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        if (!respuesta) {
          this.toastService.error('No se pudo enviar la solicitud')
          return
        }

        doc.recepcion_mercaderia = respuesta
        this.setDocAdditionalData(doc, index)
        this.toastService.success('Solicitud enviada')
        // this.buscar(this.paginationContext.CurrentPage);
      })
    })
  }

  EnvioAsignacionDocumentoRespuestaComercial = (result: 0 | 1 | 2, observacion: string, additionalData: any) => {
    const { id_lsoft, index } = additionalData

    const doc = this.listaDocumentos.filter(p => p.index === index)[0]
    doc.RespComLoading = true

    this.documentoElectronicoService.enviarRecibidoRespuestaComercial({
      empresa_rut: this.rutEmpresa,
      id_lsoft,
      result,
      observacion,
      type: 1
    }, ({ mensajes, respuesta }) => {
      doc.RespComLoading = false

      const ok = respuesta !== null && respuesta !== undefined
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      if (!respuesta) {
        this.toastService.error('No se pudo enviar la solicitud')
        return
      }

      doc.respuesta_comercial = result === 0 || result === 1 // DTE_Aceptado_OK (0) | DTE_Aceptado_con_Discrepancias (1)
      this.setDocAdditionalData(doc, index)
      this.toastService.success('Solicitud enviada')
      // this.buscar(this.paginationContext.CurrentPage);
    })
  }

}
